import { format } from 'date-fns';
import { useTranslation } from 'next-i18next';
import { Pagination, Table } from '@zep/ui';
import { StoreCategoryNumber } from '../../../consts';
import { StoreItemSale } from '../../../types';
import S from './ManageAsset.module.scss';
const SaleList = ({
  sales = [],
  lastPageNo = 1,
  nowPageNo = 1,
  handlePageChange
}: SaleListProps) => {
  const {
    t
  } = useTranslation(['store', 'manage']);
  return <div className={S.list_wrapper} data-sentry-component="SaleList" data-sentry-source-file="SaleList.tsx">
      <div className={S.list_content}>
        <Table columns={[{
        title: t('manage:manage_sales_table_title_name'),
        width: '25%',
        render: sale => sale.item.name
      }, {
        title: t('manage:manage_sales_table_title_category'),
        dataIndex: 'item',
        width: '25%',
        render: sale => {
          let category = '';
          switch (sale.item.category) {
            case StoreCategoryNumber.map:
              category = t('store:store_asset_map');
              break;
            case StoreCategoryNumber.object:
              category = t('store:store_asset_object_set');
              break;
            case StoreCategoryNumber.app:
              category = t('store:store_asset_app');
              break;
            case StoreCategoryNumber.game:
              category = t('store:store_asset_game');
              break;
          }
          return category;
        }
      }, {
        title: t('manage:manage_sales_table_title_price'),
        dataIndex: 'cashMoney',
        width: '25%',
        render: sale => `${sale.cashMoney.toLocaleString()} ZEM`
      }, {
        title: t('manage:manage_sales_table_title_date'),
        dataIndex: 'createdAt',
        width: '25%',
        render: sale => format(new Date(sale.createdAt), 'yyyy-MM-dd')
      }]} data={sales} data-sentry-element="Table" data-sentry-source-file="SaleList.tsx" />
      </div>
      <Pagination lastPageNo={lastPageNo} nowPageNo={nowPageNo} onPageChange={handlePageChange} data-sentry-element="Pagination" data-sentry-source-file="SaleList.tsx" />
    </div>;
};
export default SaleList;
type SaleListProps = {
  sales: StoreItemSale[];
  lastPageNo: number;
  nowPageNo: number;
  handlePageChange: (page: number) => void;
};